import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { ForgotPageComponent } from './forgot-password/forgot-password.component';
import { ForgotPasswordComponent } from './reset-password/forgot-password.component';

@NgModule({
  declarations: [LoginComponent, RegistrationComponent, ForgotPageComponent, ForgotPasswordComponent],
  imports: [
    CommonModule,
    AuthRoutingModule,
    SharedModule
  ]
})
export class AuthModule { }
